import i18n from "@/i18n/config";
import { useTheme } from "@/app/providers/ThemeProvider";
import { normalizeLang } from "@fysaro/shared";
import { useTranslation } from "react-i18next";

type AppTheme = "light" | "dark";

function currentTheme(): AppTheme {
  return localStorage.getItem("theme") === "dark" ? "dark" : "light";
}

export function getAppUrl(
  path: string,
  options: {
    language: string;
    theme: AppTheme;
    appBaseUrl?: string;
  },
): string {
  const base = (
    options.appBaseUrl ??
    import.meta.env.VITE_APP_SUBDOMAIN_URL ??
    ""
  ).replace(/\/$/, "");
  const url = new URL(path.startsWith("/") ? path : `/${path}`, `${base}/`);
  url.searchParams.set("lang", normalizeLang(options.language));
  url.searchParams.set("theme", options.theme === "dark" ? "dark" : "light");
  return url.toString();
}

export function redirectToApp(path: string) {
  window.location.href = getAppUrl(path, {
    language: i18n.resolvedLanguage || i18n.language,
    theme: currentTheme(),
  });
}

export function useAppHref(path: string): string {
  const { i18n: i18nInstance } = useTranslation();
  const { mode } = useTheme();
  return getAppUrl(path, {
    language: i18nInstance.resolvedLanguage || i18nInstance.language,
    theme: mode,
  });
}
